<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <i class="close" @click="$emit('btnClose')"></i>
          </div>
          <div class="modal-body">
            <slot name="body"> default body </slot>
          </div>

          <div class="custom-footer modal-footer">
            <slot name="footer">
              <!-- <span>default footer</span> -->

              <button
                class="modal-default-button btn btn-block btn-primary"
                @click="$emit('btnAction')"
              >
                {{ buttonObject.title }}
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
export default {
  name: "PdkNumber",
  data: function () {
    return {};
  },
  props: {
    buttonObject: {
      type: Object,
      required: true,
      default: () => {
        (title = "تایید"), (customclass = "btn btn-block btn-primary");
      },
    },
  },
  watch: {},

  mounted: function () {},
};
</script>

<style lang="css" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 39%);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.custom-footer {
  padding: 18px 5px 2px 5px !important;
}
.modal-container {
  width: 450px;
  margin: 0px auto;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0px 10px;
}

.modal-default-button {
  float: right;
  width: auto !important;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  background-color: azure;
  height: 40px !important;
}
.close {
  position: relative !important;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}
</style>